import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    root: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },

    message: {
        color: theme.palette.primary.main,
        fontSize: 20,
        padding: 20,
    },
}));

const LoadingPanel = props => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <CircularProgress variant="indeterminate"/>
                {props.message &&
            <h1 className={classes.message}>
                {props.message}
            </h1>}
        </div>
    );
}

export default LoadingPanel;
